var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"ml-icon-button",class:`ml-icon-button-${_vm.variant}`,on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[_c('i',{staticClass:"mr-2 icon-inherit",class:_vm.icon}),_c('span',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }